// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__jdXF4","header":"Messages_header__29gJ8"};